module.exports = __webpack_public_path__ + "static/Supplier-Intelligence-9c30759b0a2616227f6d0a68189bbb05.jpg";